module.exports = __webpack_public_path__ + "img/icon_do_witness@2x.6be612fb.png";